"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { type EcolabEvent } from "types/ContentHub/Event";

export type EventContextProps = {
  event?: EcolabEvent;
  eventSlug: string;
};

const EventContext = createContext<EventContextProps>({
  event: undefined,
  eventSlug: "",
});

interface EventProviderProps {
  children: ReactNode;
  event?: EcolabEvent;
  eventSlug: string;
}

export const EventProvider = ({
  children,
  event,
  eventSlug,
}: EventProviderProps) => {
  const contextValue = useMemo(
    () => ({ event, eventSlug }),
    [event, eventSlug],
  );
  return (
    <EventContext.Provider value={contextValue}>
      {children}
    </EventContext.Provider>
  );
};

export const useEventContext = (): EventContextProps =>
  useContext(EventContext);
